import { render } from "./Import_Share_Deposits.vue?vue&type=template&id=5f23aa0f"
import script from "./Import_Share_Deposits.vue?vue&type=script&lang=js"
export * from "./Import_Share_Deposits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__